import { Link, useLocation } from "react-router-dom";
// reactstrap components
import { Navbar, Nav, Container } from "reactstrap";
import UserProfileMenu from "components/UserProfileMenu";
import { error } from "ajv/dist/vocabularies/applicator/dependencies";
import { useEffect, useState } from "react";
import EnquiryModal from "models/enquiries.modal";

const AdminNavbar = (props) => {
  const[data, setData] = useState();
  console.log("data",data)
  // firdosh

  const GetNewEnquries = async()=>{
     EnquiryModal.listAllNewEnquiry()
     .then((responce)=>{
      console.log(responce)
      setData(responce?.data);
     })
     .catch((error)=>{})

  }
  useEffect(()=>{GetNewEnquries();},[])

  const location = useLocation();

  
  return (
    <>
      <Navbar className="navbar-top navbar-light" expand="md" id="navbar-main" style={{backgroundColor:"#f8f9fe"}}>

        <Container fluid>
          <Link
            className="h4 mb-0 text-uppercase d-none d-lg-inline-block color-red"
            to="/"
          >
            <span style={{fontSize:"32px"}}>
            {/* { location.pathname === "/admin/index" &&  "Dashboard" } */}
            </span>
            
          </Link>      

                 
            <Nav className="align-items-center d-none d-md-flex" navbar>
            <Link style={{fontWeight:"bold",color:"black",float:"right"}}  to={`/admin/newenquiries`} >
              New Enquiries <span style={{color:"blue"}}>({(data?.length > "0") ? data.length : 0}) </span>
              </Link> 
              <UserProfileMenu /> 
            </Nav>
        
        </Container>
      </Navbar>
    </>
  );
};

export default AdminNavbar;
